import type { ReactNode } from 'react';

import { PASSWORD_RULES } from '../shared/index.js';

interface PasswordRulesProps {
  readonly value: string;
  readonly showFailures?: boolean;
  readonly className?: string;
}

function Tick({ met }: { readonly met: boolean }): ReactNode {
  return (
    <svg viewBox="0 0 16 16" className="mt-[3px] size-3.5 shrink-0" aria-hidden="true">
      {met ? (
        <path
          d="M3.5 8.5l3 3 6-7"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <circle cx="8" cy="8" r="2.5" fill="currentColor" />
      )}
    </svg>
  );
}

export function PasswordRules({
  value,
  showFailures = false,
  className = '',
}: PasswordRulesProps): ReactNode {
  return (
    <ul className={`mb-4 flex flex-col gap-1 ${className}`}>
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(value);
        const tone = met ? 'text-positive' : showFailures ? 'text-critical' : 'text-muted';

        return (
          <li key={rule.id} className={`flex items-start gap-1.5 text-[12.5px] ${tone}`}>
            <Tick met={met} />
            <span>{rule.label.charAt(0).toUpperCase() + rule.label.slice(1)}</span>
          </li>
        );
      })}
    </ul>
  );
}
